export default "__VITE_ASSET__CoI1TtNN__"